import { render, staticRenderFns } from "./CommandForm.vue?vue&type=template&id=2115809c&scoped=true&"
import script from "./CommandForm.vue?vue&type=script&lang=js&"
export * from "./CommandForm.vue?vue&type=script&lang=js&"
import style0 from "./CommandForm.vue?vue&type=style&index=0&id=2115809c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2115809c",
  null
  
)

export default component.exports